<template>
    <page :tabs="tabs" :busy="busy">
        <div class="w-100 h-100">
            <div class="google-map w-100 h-100" ref="googleMap"></div>
        </div>
    </page>
</template>

<script>
import GoogleMapsApiLoader from 'google-maps-api-loader';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import { ADMIN_PROPERTY_MAP_MARKERS_ENDPOINT } from '../../endpoints';
import page from '../generic/page/page.vue';
import API from '../../api';
import { removeScrollMixin } from '../../mixins/remove-scroll-mixin';

export default {
    components: { page },
    data() {
        return {
            busy: null,
            tabs: [{ title: 'Property Map', active: true }],
            google: null,
            map: null,
            markers: [],
        };
    },
    mixins: [removeScrollMixin],
    async mounted() {
        const googleMapApi = await GoogleMapsApiLoader({
            apiKey: window.GOOGLE_MAPS_KEY,
        });
        await this.fetchMarkers();
        this.google = googleMapApi;
        await this.initializeMap();
        this.setMarkers();
    },
    methods: {
        async initializeMap() {
            const mapContainer = this.$refs.googleMap;
            this.map = new this.google.maps.Map(mapContainer, {
                center: { lat: 28, lng: -81 },
                zoom: 7,
            });
        },
        async fetchMarkers() {
            try {
                this.busy = true;
                const response = await API.post(
                    ADMIN_PROPERTY_MAP_MARKERS_ENDPOINT()
                );
                this.markers = response.data;
            } catch (e) {
                this.errorToast({ text: 'Could not load markers' });
            } finally {
                this.busy = false;
            }
        },
        setMarkers() {
            const markers = this.markers.map((item) => {
                const { address, name, id, subscriber, url } = item;

                const infowindow = new this.google.maps.InfoWindow({
                    content: `${name}<br/>Subscriber: ${subscriber}`,
                });
                const marker = new this.google.maps.Marker({
                    zIndex: 1,
                    position: { lat: address.latitude, lng: address.longitude },
                    map: this.map,
                    title: `${name}\nSubscribers:${subscriber}`,
                    draggable: false,
                });
                marker.addListener('click', () => {
                    infowindow.open(this.map, marker);
                });
                return marker;
            });
            new MarkerClusterer(this.map, markers, {
                imagePath:
                    'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
            });
        },
    },
};
</script>